import { Box } from "@mui/material";
import Text from "../ui/Text";

const SIZE = 56;
const STROKE = 4;
const RADIUS = (SIZE - STROKE) / 2;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

const Stepper = ({ steps, activeStep }) => {
  const total = steps.length;
  const progress = Math.min(1, Math.max(0, activeStep / total));
  const dashOffset = CIRCUMFERENCE * (1 - progress);

  const currentLabel = steps[activeStep - 1]?.label || "";
  const nextLabel = steps[activeStep]?.label;

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 3 }}>
      <Box
        sx={{ position: "relative", width: SIZE, height: SIZE, flexShrink: 0 }}
      >
        <svg width={SIZE} height={SIZE} viewBox={`0 0 ${SIZE} ${SIZE}`}>
          <circle
            cx={SIZE / 2}
            cy={SIZE / 2}
            r={RADIUS}
            fill="none"
            stroke="#D9D9D9"
            strokeWidth={STROKE}
          />
          <circle
            cx={SIZE / 2}
            cy={SIZE / 2}
            r={RADIUS}
            fill="none"
            stroke="#1890FF"
            strokeWidth={STROKE}
            strokeLinecap="round"
            strokeDasharray={CIRCUMFERENCE}
            strokeDashoffset={dashOffset}
            transform={`rotate(-90 ${SIZE / 2} ${SIZE / 2})`}
            style={{ transition: "stroke-dashoffset 0.2s ease" }}
          />
        </svg>
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Text
            variant="paragraph3"
            sx={{ fontWeight: 600, fontSize: "12px", whiteSpace: "nowrap" }}
          >
            {activeStep} of {total}
          </Text>
        </Box>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", minWidth: 0 }}>
        <Text variant="subtitle1" sx={{ fontSize: "18px" }}>
          {currentLabel}
        </Text>
        {nextLabel && (
          <Text variant="paragraph3" sx={{ color: "#A1A1A1" }}>
            Next: {nextLabel}
          </Text>
        )}
      </Box>
    </Box>
  );
};

export default Stepper;
